import React from 'react';
import { Button, Grid, Typography } from '@mui/material';
import { Form } from 'formik';
import * as Yup from 'yup';
import { MuiForm } from 'lib/Form';
import { SelectFormField } from 'lib/form/fields/SelectFormField';
import { TextFormField } from 'lib/form/fields/TextFormField';
import { MuiFormLabel } from 'lib/form/MuiFormLabel';
import { LoadingButton } from 'ui/buttons/LoadingButton';
import { Row } from 'ui/Flex';
import { AudienceType } from '../models/segmentModel';
import { TimeMeasure } from 'lib/timeHelpers';

export interface AudienceEditTimeFormData {
    measure: TimeMeasure;
    value: number;
}

interface AudienceEditTimeFormProps {
    onClose: () => void;
    onSubmit: (data: AudienceEditTimeFormData) => void;
    initialData?: Partial<AudienceEditTimeFormData>;
}

const initialValues: AudienceEditTimeFormData = {
    measure: TimeMeasure.DAY,
    value: 0
};

const measureOptions = [
    { label: 'Week(s)', value: TimeMeasure.WEEK },
    { label: 'Day(s)', value: TimeMeasure.DAY },
    { label: 'Hour(s)', value: TimeMeasure.HOUR }
];

const reg = /^\d+$/;

const validationSchema = Yup.object().shape({
    value: Yup.mixed().when('type', {
        is: (target: string) => target !== AudienceType.PERSISTENT,
        then: Yup.mixed()
            .required('This field is required.')
            .test('', 'This field must be higher than zero.', value => reg.test(value) && value > 0),
        otherwise: Yup.mixed().notRequired()
    })
});

export const AudienceEditTimeForm: React.FC<AudienceEditTimeFormProps> = ({
    onSubmit,
    onClose,
    initialData = {}
}) => (
    <MuiForm
        onSubmit={onSubmit}
        initialValues={{ ...initialValues, ...initialData }}
        validationSchema={validationSchema}
    >
        {({ submitForm, isSubmitting }) => (
            <Form>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography color="primary" variant="h6">
                            Edit Expiry Time
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextFormField
                            name="value"
                            type="number"
                            shrink
                            label={<MuiFormLabel required>Expires After</MuiFormLabel>}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <SelectFormField
                            options={measureOptions}
                            name="measure"
                            label={<MuiFormLabel> </MuiFormLabel>}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Row gutter align="flex-end" valign="center">
                            <Button
                                disabled={isSubmitting}
                                onClick={onClose}
                                color="primary"
                                variant="outlined"
                            >
                                Cancel
                            </Button>
                            <LoadingButton
                                variant="contained"
                                color="primary"
                                disabled={isSubmitting}
                                loading={isSubmitting}
                                onClick={submitForm}
                            >
                                Submit
                            </LoadingButton>
                        </Row>
                    </Grid>
                </Grid>
            </Form>
        )}
    </MuiForm>
);
